module.exports = __webpack_public_path__ + "img/exhibit-virtual-launch.fac7f3c3.jpg";